import { ReactNode } from 'react'
import { styled, TypographyVariant } from '@mui/material/styles'
import { Typography, SxProps, TypographyProps } from '@mui/material'

const Root = styled('div')`
  display: flex;
  flex-direction: column;

  background-color: #fff;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 13px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
  text-align: right;
`

const Header = styled('div')`
  display: flex;
  align-items: center;
  margin: 10px 15px 3px 0;
`

interface Props {
  headerText?: string
  headerIcon?: JSX.Element
  sx?: SxProps
  headerSx?: SxProps
  children: ReactNode
  headerVariant?: TypographyVariant
  headerColor?: TypographyProps['color']
  onEndIconClick?: () => unknown
  sx?: SxProps
  className?: string
}

export function SettingsSection({
  headerText = '',
  headerIcon,
  children,
  headerVariant,
  headerColor,
  sx,
  headerSx,
  className,
}: Props) {
  return (
    <Root sx={sx} className={className}>
      <>
        {headerText && (
          <Header sx={headerSx}>
            {headerIcon && (
              <div style={{ width: '16px', height: '16px' }}>{headerIcon}</div>
            )}

            <Typography
              color={headerColor || 'primary'}
              variant={headerVariant || 'subtitle3'}
              sx={{ marginRight: headerIcon ? '5px' : 0 }}
            >
              {headerText}
            </Typography>
          </Header>
        )}

        {children}
      </>
    </Root>
  )
}
